import type { TSkeletons } from '@frontend/pole-ui/lib/components/Skeleton'

export const skeletons: TSkeletons = [
  {
    className: 'becomePartners__slide',
    width: '100%',
    height: '210px',
  },
]
